import {useAppSelector} from 'hooks';
import {AppMode} from 'store/types/app';

interface IAppMode {
  appMode: AppMode;
  isExpress: boolean;
  isRegular: boolean;
}

export const useAppMode = (): IAppMode => {
  const appMode = useAppSelector((state) => state.app.appMode);

  const isExpress = appMode === AppMode.express;

  return {
    appMode,
    isExpress,
    isRegular: !isExpress
  };
};
